import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function historico (dados) {
  let parametros = '?usuario_id=' + dados.usuario
  if (dados) {
    if (dados.page) {
      parametros += '&page=' + dados.page
    }
    if (dados.tipo) {
      parametros += '&tipo_id=' + dados.tipo.value
    }
    if (dados.tipo) {
      parametros += '&tipo=' + dados.tipo
    }
    if (dados.data_inicial || dados.data_final) {
      parametros += '&createdAt=' + dados.data_inicial || '' + '&createdAt=' + dados.data_final || ''
    }
  }
  return sessaoFetchLoading(`base`, `/relatorio/unidade/movimentacao${parametros}`)
}

export async function historicoFornecedor (dados) {
  let created = ''
  if (dados) {
    if (dados.data_inicial && dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt=' + dados.data_final
    } else if (dados.data_inicial && !dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt='
    } else if (!dados.data_inicial && dados.data_final) {
      created = '&createdAt=&createdAt=' + dados.data_final
    }
  }
  let dadosserial = serialize(dados) + created
  return sessaoFetchLoading(`base`, `/relatorio/fornecedor/movimentacao?${dadosserial}`)
}

export async function historicoUnidade (dados) {
  let created = ''
  if (dados) {
    if (dados.data_inicial && dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt=' + dados.data_final
    } else if (dados.data_inicial && !dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt='
    } else if (!dados.data_inicial && dados.data_final) {
      created = '&createdAt=&createdAt=' + dados.data_final
    }
  }
  let dadosserial = serialize(dados) + created
  return sessaoFetchLoading(`base`, `/relatorio/unidade/movimentacao?${dadosserial}`)
}

export async function getConsultasParceiros (filtro) {
  return sessaoFetchLoading(`base`, `/consulta/relatoriounidade?${serialize(filtro)}`)
}



// WEBPACK FOOTER //
// ./src/api/movimentacoes.js